import { Variant, Variants } from "@kernel/react-ui-kit";
import { ErrorToast } from "./ErrorToast";

export class HttpNotFoundErrorToast extends ErrorToast {
  public header(): string {
    return "Endpoint non trovato!";
  }

  public bg(): Variant {
    return Variants.WARNING;
  }
}
